import React from 'react';
import './AiLoadingIcon.css';

interface IconLoaderProps {
  size?: number;
  className?: string;
}

export const AiLoadingIcon: React.FC<IconLoaderProps> = ({
  size = 200,
  className = ''
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-loader ${className}`}
      aria-label="AI is thinking"
      role="img"
    >
      <rect width="200" height="200" rx="100" fill="#F7F1FF" />
      <path
        d="M99.9922 35.7148C101.905 35.7148 103.766 36.3409 105.29 37.4971C106.719 38.581 107.779 40.0748 108.331 41.7754L108.435 42.1182L108.466 42.2344L117.704 78.0859C117.965 79.0972 118.493 80.0203 119.231 80.7588C119.97 81.4971 120.892 82.0243 121.903 82.2852H121.902L157.755 91.5244L157.851 91.5498C159.585 92.0281 161.127 93.0273 162.271 94.4082L162.494 94.6895L162.705 94.9795C163.732 96.4493 164.286 98.2012 164.286 100C164.286 101.919 163.656 103.784 162.494 105.311C161.332 106.837 159.7 107.94 157.851 108.45C157.819 108.459 157.787 108.467 157.755 108.476L121.902 117.716L121.901 117.715C120.891 117.976 119.969 118.503 119.231 119.241C118.493 119.98 117.966 120.903 117.705 121.914L108.46 157.767C108.45 157.805 108.439 157.844 108.429 157.882C107.913 159.724 106.808 161.348 105.284 162.504C103.76 163.66 101.899 164.285 99.9863 164.285C98.0736 164.285 96.2134 163.66 94.6895 162.504C93.1653 161.348 92.0605 159.724 91.5449 157.882C91.5341 157.843 91.5237 157.804 91.5137 157.766L82.2744 121.913C82.0135 120.902 81.4863 119.979 80.748 119.241C80.102 118.595 79.3151 118.111 78.4512 117.825L78.0762 117.715L42.2236 108.47C42.178 108.458 42.1323 108.445 42.0869 108.433C40.2521 107.912 38.6373 106.807 37.4873 105.285C36.3373 103.763 35.7148 101.908 35.7148 100C35.7149 98.0925 36.3373 96.2367 37.4873 94.7148C38.6373 93.1932 40.2521 92.0882 42.0869 91.5674L42.2227 91.5303L78.0752 82.2793H78.0771C79.0879 82.0186 80.0107 81.4917 80.749 80.7539C81.4873 80.016 82.0141 79.0936 82.2754 78.083L91.5195 42.2334C91.5295 42.1949 91.5401 42.1565 91.5508 42.1182C92.0663 40.2761 93.1704 38.6532 94.6943 37.4971C96.2184 36.341 98.0793 35.7149 99.9922 35.7148ZM53.2354 123.375C56.4629 123.375 59.0791 125.991 59.0791 129.219C62.3064 129.219 64.9229 131.835 64.9229 135.062C64.9229 138.29 62.3064 140.906 59.0791 140.906V140.907C59.0788 144.135 56.4627 146.751 53.2354 146.751C50.008 146.751 47.3919 144.135 47.3916 140.907V140.906H47.3906C44.1631 140.906 41.5469 138.29 41.5469 135.062C41.5469 131.835 44.1631 129.219 47.3906 129.219H47.3916C47.3916 125.991 50.0078 123.375 53.2354 123.375ZM93.5928 81.0049L93.5918 81.0088C92.8078 84.0408 91.2259 86.8078 89.0107 89.0215C86.7956 91.235 84.0274 92.8138 80.9951 93.5957L80.9961 93.5967L56.1816 99.999L80.9951 106.397L81.5615 106.554C84.3732 107.38 86.9359 108.9 89.0127 110.977C91.228 113.192 92.8092 115.961 93.5918 118.994L93.5928 118.996L99.9873 143.811L106.387 118.994C107.169 115.96 108.751 113.192 110.967 110.977C113.182 108.761 115.951 107.18 118.984 106.397H118.985L143.809 100L118.985 93.6025H118.984C115.951 92.82 113.182 91.2387 110.967 89.0234C108.751 86.8081 107.169 84.0395 106.387 81.0059V81.0049L99.9912 56.1885L93.5928 81.0049ZM146.739 41.5586C149.967 41.5586 152.583 44.1748 152.583 47.4023V53.2461H158.427C161.654 53.2461 164.271 55.8623 164.271 59.0898C164.271 62.3174 161.654 64.9336 158.427 64.9336H152.583V70.7783C152.583 74.0059 149.967 76.6221 146.739 76.6221C143.512 76.6221 140.896 74.0059 140.896 70.7783V64.9336H135.051C131.823 64.9336 129.207 62.3174 129.207 59.0898C129.207 55.8623 131.823 53.2461 135.051 53.2461H140.896V47.4023C140.896 44.1748 143.512 41.5586 146.739 41.5586Z"
        fill="url(#animatedGradient)"
        fillOpacity="0.88"
      />
      <defs>
        <linearGradient
          id="animatedGradient"
          x1="148.756"
          y1="164.285"
          x2="23.9602"
          y2="126.972"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.139423" className="gradient-stop-1">
            <animate
              attributeName="stop-color"
              values="#9747FF;#DE8FD2;#9747FF"
              dur="1s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="0.860577" className="gradient-stop-2">
            <animate
              attributeName="stop-color"
              values="#2F54EB;#D5C6E8;#2F54EB"
              dur="1s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default AiLoadingIcon;


